import { flow, applySnapshot } from 'mobx-state-tree';
import { getIdentifier, toMapById } from '~/mst/utils';
import api from '~/api';
import type { IOrganization } from '../organization';
import type { IOrganizationsModel } from './model';

export default (self: IOrganizationsModel) => ({
  fetch: flow(function* fetch(params = {}, options?) {
    try {
      self.startFetching();
      const { data } = yield self.sync(api.organizations.fetch, params, options);
      applySnapshot(self.models, toMapById(data, 'id'));
      self.finishFetching();
    } catch (error) {
      self.failFetching(error);
    }
  }),
  create: flow(function* create(payload, model: IOrganization) {
    model.startSyncing();
    try {
      const { data } = yield api.organizations.create(payload);
      self.models.put(data);
      model.finishSyncing();
      return data;
    } catch (error) {
      model.failSyncing(error);
    }
    return null;
  }),
  destroy: flow(function* destroy(model) {
    model.startSyncing();
    try {
      yield api.organizations.destroy(getIdentifier(model));
      self.remove(model);
    } catch (error) {
      model.failSyncing(error);
    }
  })
});
